export const getAdditionalContextFromVariantAndProduct = (product, context) => {
  const selectedVariant = product?.variants?.find(
    (variant) => variant.isSelected,
  );
  if (selectedVariant?.price?.additionalContexts) {
    const variantContext = selectedVariant.price.additionalContexts.find(
      (item) => item.context === context,
    );
    if (variantContext) return variantContext;
  }
  return product?.price?.additionalContexts?.find(
    (item) => item.context === context,
  );
};

export const getAdditionalContextFromProduct = (product, context) =>
  product?.price?.additionalContexts?.find((item) => item.context === context);
